(function (window, document) {
  const SELECTOR = "[data-mvt-countdown]";
  const TICK_MS = 1000;

  let timer = null;
  let observer = null;

  function pad(value) {
    return value < 10 ? "0" + value : String(value);
  }

  function resolveDeadline(element) {
    const until = element.getAttribute("data-mvt-countdown-until");
    if (until) {
      const parsed = Date.parse(until);
      return isNaN(parsed) ? null : parsed;
    }

    const minutes = parseFloat(element.getAttribute("data-mvt-countdown-minutes"));
    if (isNaN(minutes) || minutes <= 0) {
      return null;
    }

    if (element._mvtDeadline) {
      return element._mvtDeadline;
    }

    const key = "mvt_countdown_" + (element.getAttribute("data-mvt-countdown") || "default");
    let stored = null;
    try {
      stored = window.sessionStorage.getItem(key);
    } catch (e) {
      stored = null;
    }

    let deadline = stored ? parseInt(stored, 10) : NaN;
    if (isNaN(deadline)) {
      deadline = Date.now() + minutes * 60 * 1000;
      try {
        window.sessionStorage.setItem(key, String(deadline));
      } catch (e) {}
    }

    element._mvtDeadline = deadline;
    return deadline;
  }

  function render(element) {
    const deadline = resolveDeadline(element);
    if (deadline === null) {
      return;
    }

    let remaining = Math.max(0, deadline - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    const parts = {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };

    for (const unit of Object.keys(parts)) {
      const slot = element.querySelector('[data-mvt-countdown-unit="' + unit + '"]');
      if (slot) {
        const next = pad(parts[unit]);

        if (slot.textContent !== next) {
          slot.textContent = next;
        }
      }
    }

    if (remaining === 0 && !element.hasAttribute("data-mvt-countdown-done")) {
      element.setAttribute("data-mvt-countdown-done", "true");
      const onZero = element.getAttribute("data-mvt-countdown-onzero");
      if (onZero === "hide") {
        element.style.display = "none";
      }
    }
  }

  function renderAll() {
    const elements = document.querySelectorAll(SELECTOR);
    for (let i = 0; i < elements.length; i++) {
      render(elements[i]);
    }
    return elements.length;
  }

  const COUNTDOWN = {
    start: function () {
      renderAll();

      if (timer === null) {
        timer = window.setInterval(renderAll, TICK_MS);
      }

      if (observer === null && typeof window.MutationObserver === "function") {
        observer = new window.MutationObserver(function () {
          renderAll();
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
      }
    },

    stop: function () {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
      if (observer !== null) {
        observer.disconnect();
        observer = null;
      }
    },

    refresh: renderAll,
  };

  window.MVTCountdown = COUNTDOWN;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      COUNTDOWN.start();
    });
  } else {
    COUNTDOWN.start();
  }
})(window, document);
